import { useState, useEffect } from 'react';

export default function SpecialOffers() {
  const offers = [
    {
      airline: 'Emirates',
      route: 'London → Dubai → Karachi',
      price: '£459',
      dates: 'Valid: Jan 15 - Mar 31, 2025',
      savings: 'Save £180',
      icon: 'ri-flight-takeoff-line',
    },
    {
      airline: 'Qatar Airways',
      route: 'London → Doha → Lahore',
      price: '£485',
      dates: 'Valid: Feb 1 - Apr 30, 2025',
      savings: 'Save £165',
      icon: 'ri-plane-line',
    },
    {
      airline: 'Turkish Airlines',
      route: 'London → Istanbul → Islamabad',
      price: '£425',
      dates: 'Valid: Jan 20 - Mar 15, 2025',
      savings: 'Save £195',
      icon: 'ri-flight-land-line',
    },
    {
      airline: 'Saudi Airlines',
      route: 'London → Jeddah (Umrah Special)',
      price: '£399',
      dates: 'Valid: Ramadan 2025',
      savings: 'Save £220',
      icon: 'ri-ancient-gate-line',
    },
  ];

  const [timeLeft, setTimeLeft] = useState({
    days: 5,
    hours: 12,
    minutes: 45,
    seconds: 30,
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let { days, hours, minutes, seconds } = prev;
        
        if (seconds > 0) {
          seconds--;
        } else {
          seconds = 59;
          if (minutes > 0) {
            minutes--;
          } else {
            minutes = 59;
            if (hours > 0) {
              hours--;
            } else {
              hours = 23;
              if (days > 0) {
                days--;
              }
            }
          }
        }
        
        return { days, hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleBookNow = (route: string) => {
    const message = `Hello Alwaz Travels, I'm interested in the special offer: ${route}`;
    window.open(`https://wa.me/447362505895?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Flight Deals This Week – Limited Time Offers
          </h2>
          <p className="text-lg text-gray-600 mb-6">Exclusive negotiated fares available for a limited time only</p>
          
          <div className="inline-flex items-center gap-6 bg-gradient-to-r from-red-500 to-orange-500 text-white px-8 py-4 rounded-full shadow-lg">
            <span className="font-semibold text-sm">Offer Ends In:</span>
            <div className="flex gap-4">
              <div className="text-center">
                <div className="text-2xl font-bold">{timeLeft.days}</div>
                <div className="text-xs opacity-90">Days</div>
              </div>
              <div className="text-2xl font-bold">:</div>
              <div className="text-center">
                <div className="text-2xl font-bold">{String(timeLeft.hours).padStart(2, '0')}</div>
                <div className="text-xs opacity-90">Hours</div>
              </div>
              <div className="text-2xl font-bold">:</div>
              <div className="text-center">
                <div className="text-2xl font-bold">{String(timeLeft.minutes).padStart(2, '0')}</div>
                <div className="text-xs opacity-90">Mins</div>
              </div>
              <div className="text-2xl font-bold">:</div>
              <div className="text-center">
                <div className="text-2xl font-bold">{String(timeLeft.seconds).padStart(2, '0')}</div>
                <div className="text-xs opacity-90">Secs</div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {offers.map((offer, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-200 rounded-xl p-6 hover:border-[#14B8A6] hover:shadow-xl transition-all duration-300 relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg">
                HOT DEAL
              </div>
              
              <div className="w-12 h-12 bg-gradient-to-br from-[#14B8A6] to-[#0F9688] rounded-lg flex items-center justify-center mb-4">
                <i className={`${offer.icon} text-white text-xl`}></i>
              </div>

              <h3 className="text-lg font-bold text-gray-900 mb-2">{offer.airline}</h3>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">{offer.route}</p>

              <div className="mb-4">
                <div className="text-3xl font-bold text-[#14B8A6] mb-1">
                  {offer.price}
                </div>
                <div className="text-xs text-green-600 font-semibold">{offer.savings}</div>
              </div>

              <div className="text-xs text-gray-500 mb-4 pb-4 border-b border-gray-200">
                {offer.dates}
              </div>

              <button
                onClick={() => handleBookNow(offer.route)}
                className="w-full bg-[#14B8A6] text-white py-3 rounded-lg font-semibold hover:bg-[#0F9688] transition-colors flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line"></i>
                Book Now
              </button>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500">
            * Prices are subject to availability. Terms and conditions apply. Contact us for full details.
          </p>
        </div>
      </div>
    </section>
  );
}
